export default function (bankAccount, branchCode, affiliation) {
    return `${bankAccount} Filial: ${branchCode} - ${affiliation}`;
}
